
    export default {
        name: 'JobCardBasicShimmer',

        data() {
            return {
            };
        },
    };
